export default function QuoteSection() {
  return;
}